import { z } from "zod";
import { zEmailSchema, zString } from "./commonSchemaObjects";

export const userLoginSchema = z.object({
  email: zEmailSchema,
  password:  zString.zRequired,
});
